
import React, { useEffect, useState, useRef } from 'react';
import { Form, Input, Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { isValidEmail, isEmptyValue } from '../_config/common';
import * as service from '@/pages/home/services/login';
import { useIntl } from 'umi';

export default function EmailForgetPassword(props: any) {
  const {
    email,
    onBack = () => console.log,
    onError = () => console.log,
  } = props;
  const { formatMessage } = useIntl()
  // 邮箱
  const [statusEmail, setStatusEmail] = useState<string | null>(null);
  const [valueEmail, setValueEmail] = useState<string>(email);
  const [successEmail, setSuccessEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  //验证码
  const [expires, setExpires] = useState(0)
  const [isDisabled, setIsDisabled] = useState(false)

  useEffect(() => {
    /**从外面传过来的时候空值不做校验 */
    if (email) {
      onEmailBuleClick(email);
    }
    setValueEmail(email);
  }, [email])

  const onEmailChangClick = (val: string) => {
    setValueEmail(val);
  }
  const onEmailBuleClick = (email = valueEmail) => {
    if (isEmptyValue(email)) {
      setStatusEmail('dbh_login_no_email_entered')
      setSuccessEmail(false)
      return false;
    } else if (isValidEmail(email)) {
      setStatusEmail(null)
      setSuccessEmail(true)
      return true;
    } else {
      setStatusEmail('dbh_login_email_format_error')
      setSuccessEmail(false)
      return false;
    }
  }

  const timeRef = useRef<NodeJS.Timer>();

  useEffect(() => {
    timeRef.current = setInterval(() => {
      if (expires <= 1) {
        clearInterval(timeRef.current);
        setIsDisabled(false)
      } else {
        setExpires(expires - 1)
      }
    }, 1000)
    return () => {
      clearInterval(timeRef.current)
    }
  }, [expires]);

  // 发送验证码
  const [isSendCode, setIsSendCode] = useState(false)

  const handleSendCode = async () => {
    const _successEmail = onEmailBuleClick();
    if (loading || !_successEmail) {
      return;
    }
    try {
      setLoading(true);
      const res: any = await service.sendResetEmail({ email: valueEmail })
      setExpires(res?.expired);
      setIsSendCode(true)
      setIsDisabled(true)
    } catch (err: any) {
      if (err?.code === 20005) {
        //20005  "Data error"
        setStatusEmail('dbh_login_incorrect_email')
        setSuccessEmail(false)
      } else {
        onError(err?.msg, err?.code)
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='login-cont-email login-cont-email--forgetpasswords'>
      <div className='login-cont'>
        <div className='login-cont-title'>{formatMessage({ id: 'dbh_login_forget_password' })}</div>

        {
          isSendCode ? (
            <div className='login-cont-email-sedcode'>
              <div className='login-cont-email-icon'>
                <SvgIcon className='email-success' type="youjianchenggong" />
              </div>

              <div className='login-cont-email-text'>{formatMessage({ id: 'dbh_login_password_reset_link' })}</div>
              <div className='login-cont-email-txt'>
                {formatMessage({ id: 'dbh_login_password_reset_link_desc' })}
              </div>
              <div className='login-cont-email-line'></div>
              <div className='login-cont-email-errortxt'>{formatMessage({ id: 'dbh_login_didnot_receive_email' })}<br /> &lt;databrain@proximabeta.com&gt;?</div>

              <div className='login-cont-from-btn'>
                <Button type="link" disabled={isDisabled} onClick={() => {
                  handleSendCode()
                  setIsDisabled(true)
                }}>
                  {formatMessage({ id: 'dbh_login_resend_confirm' })}
                  {isDisabled && <span>{expires}s</span>}
                </Button>
                <Button type="link" onClick={onBack}>
                  {formatMessage({ id: 'dbh_login_goback_tologin' })}
                </Button>
              </div>
            </div>
          ) : (
            <div className='login-cont-email-sedemail'>
              <div className='login-cont-desc'>
                <div> {formatMessage({ id: 'dbh_login_forget_emailpassowrd_desc' })}</div>
              </div>

              <Form.Item label="" status={successEmail ? 'success' : statusEmail ? 'error' : undefined} message={statusEmail ? formatMessage({ id: statusEmail }) : undefined}>
                <Input
                  placeholder={formatMessage({ id: 'dbh_login_email_placeholder' })}
                  value={valueEmail}
                  onChange={(val) => { onEmailChangClick(val) }}
                  onBlur={() => { onEmailBuleClick(valueEmail) }}
                />
              </Form.Item>

              <div className='login-cont-from-btn'>
                <Button type="primary" onClick={handleSendCode} loading={loading}>
                  {formatMessage({ id: 'dbh_login_send_code' })}
                </Button>
                <Button type="link" onClick={onBack}>
                  {formatMessage({ id: 'dbh_login_goback_tologin' })}
                </Button>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}
